import { Pill } from './Pill';
import { departmentChip, flagChip, type ProductFlag } from '../lib/productChips';

export function DepartmentChip({ department }: { department: string | null | undefined }) {
  const c = departmentChip(department);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}

export function FlagChip({ flag }: { flag: ProductFlag }) {
  const c = flagChip(flag);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}
